module.exports = __webpack_public_path__ + "img/interconsultas.405b62af.png";